import { TChartFileInfoList } from 'types/chart';

export type TEvaluationChartListByPatientParams = {
  courseInfoId: number;
  chartRound: number;
  sortBy?: PatientDetailEvaluationChartSortBy;
  isAsc?: boolean;
};

export type TEvaluationChartListByRegisteredChartParams = {
  searchWord?: string;
  courseInfoId: number;
  chartRound: number;
  isUnCreated?: boolean;
};

export type TEvaluationChartByPatientTableInfo = {
  evaluationChartId: number;
  evaluationRound: number;
  chartTypeNum: number;
  chartTypeName: string;
  registeredChartName: string;
  lastModifiedAt: string;
  evaluationAvgScore: string;
};

export type TEvaluationChartListByPatientResponse = {
  evaluationChartList: TEvaluationChartByPatientTableInfo[];
};

export type TEvaluationChartByRegisteredChartTableInfo = {
  registeredChartId: number;
  evaluationChartId: number | null;
  evaluationRound: number | null;
  chartTypeNum: number;
  chartTypeName: string;
  patientId: number | null;
  patientName: string;
  firstSubmitDate: string;
  secondSubmitDate: string;
  isOpened: boolean;
  submitStartDate: string;
  isClosed: boolean;
  isEvaluationComplete: boolean;
};

export type TEvaluationChartListByRegisteredChartResponse = {
  registeredChartList: TEvaluationChartByRegisteredChartTableInfo[];
};

export enum EvaluationChartTable {
  PatientId = 'patientId',
  RegisteredChartName = 'registeredChartName',
  ChartTypeName = 'chartTypeName',
  LastModifiedAt = 'lastModifiedAt',
  EvaluationAvgScore = 'evaluationAvgScore',
}

export type TCheckSamePatientParams = {
  patientId: number;
  courseInfoId: number;
  registeredChartId: number;
  chartTypeNum: number;
};

export type TCheckSamePatientResponse = {
  isSamePatient: boolean;
  createdEvaluationChartId: number;
  evaluationChartRound: number;
  evaluationChartIdList: string;
  chartRound: number;
  patientName: string;
  evaluationChartCnt: number;
};

export type TRegisterChartParams = {
  isSamePatient: boolean;
  password?: string;
  evaluationChartIdList?: string;
  registerRequest: {
    patientId: number;
    courseInfoId: number;
    registeredChartId: number;
    chartTypeNum: number;
  };
};

export type TRegisterChartResponse = {
  evaluationChartId: number;
  evaluationRound: number;
};

export type TEvaluationChartInfoParams = {
  patientId: string;
  courseInfoId: string;
  chartRound: string;
  chartTypeNum: number;
};

export type TEvaluationChartInfo = {
  evaluationRound: string;
  evaluationChartId: number;
  submitEndDate: string;
  chartData: object;
  fileInfoList?: TChartFileInfoList[];
  disclosureStatus?: boolean;
  score?: number;
  feedbackId?: number;
  feedbackContent?: string;
  feedbackImage?: string;
};

export type TEvaluationChartInfoResponse = {
  chartName: string;
  chartInfo: TEvaluationChartInfo[];
};

export type TPutEvaluationChartResponse = {
  chartInfo: {
    chartData: any | null;
    fileInfoList: TChartFileInfoList[] | null;
  } | null;
};

export enum PatientDetailEvaluationChartSortBy {
  LastModifiedAt = 'lastModifiedAt',
  Score = 'score',
}
